export var AbilitySubjectType = /*#__PURE__*/function (AbilitySubjectType) {
  AbilitySubjectType["Feature"] = "Feature";
  AbilitySubjectType["Item"] = "Item";
  AbilitySubjectType["Programmatic"] = "Programmatic";
  return AbilitySubjectType;
}(AbilitySubjectType || {});